(function(angular){
	'use strict';

	angular
		.module('highPerformanceHighPotentialChartModule')
		.directive('highPerformanceHighPotentialChart', [
			'$window',
			'BREAKPOINTS',
			'HIGHCHARTS_OPTIONS', 
			'STATIC_BASE_PATH',
			highPerformanceHighPotentialChartFunction
		]);

	function highPerformanceHighPotentialChartFunction(
		$window,
		BREAKPOINTS,
		HIGHCHARTS_OPTIONS,
		STATIC_BASE_PATH) {
		return {
			replace: true,
			restrict: 'E',
			scope: {},
			template: "<div id='high-performance-high-potential-chart' class='coterminous'></div>",
			link: function($scope, $attrs, $elem) {
				Highcharts.setOptions(HIGHCHARTS_OPTIONS());

				var fontSize = '14px';
				var yAxisTitle = 'Aggregate Funds Invested*';

				if($window.innerWidth < BREAKPOINTS.MD_START) {
					fontSize = '10px';
					yAxisTitle = null;
				}
				
				var dataLabelSettings = function(offsetY, classSuffix) {
					
					return {
						className: "fcx-high-performance-chart-annotation fcx-high-performance-chart-annotation-" + classSuffix + " ",
						enabled: true,
						formatter: function() {
							return this.series.name;
						},
						crop: false,
						overflow: "none",
						style: {
							fontSize: fontSize,
							fontWeight: "normal",
							shadow: "none",
							color: "#242628"
						},
						useHTML: true,
						y: offsetY
					};
				};
					
				var data = {
					crowdFunding: {
						historical: [{y: 325000, marker: {enabled: true}, dataLabels: dataLabelSettings(-32, 1)}, 325000, 325000, 325000, 325000, 325000, 325000, 675000, 675000, 675000, 675000, 675000, 675000, 675000, 675000, 675000, 675000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000, 1025000]
					},
					privateOfferings: {
						historical: [{y: 250000, marker: {enabled: true}, dataLabels: dataLabelSettings(-96, 2)}, 1250000, 1800000, 2050000, 2775000, 3565000, 4165000, 6325000, 6325000, 7975000, 9705000, 10455000, 15095000, 19210000, 19210000, 23080000, 29545000, 38195000, 46195000, 52745000, 58145000, 62745000, 65915000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000, 66555000]
					},
					reit: {
						historical: [{y: 0, marker: {enabled: true}, dataLabels: dataLabelSettings(-64, 3)}, 13218080.00, 20029480.00, 26109130.00, 43293770.00, 54277480.00, 59763280.00, 68260620.00, 74279790.00, 82279140.00, 90407190.00, 104212370.00, 110841610.00, 121341010.00, 127286560.00, 131102880.00, 138117000.00, 145686770.00, 152294229.68, 160785695.14, 172830640.08, 184463553.34, 195648891.95, 205850632.91, 215290258.58, 227019927.75]
					},
					efunds: {
						historical: [{y: 12526.98, marker: {enabled: true}, dataLabels: dataLabelSettings(-32, 1)}, 3212664.79, 6516005.45, 9282902.14, 11711956.46, 14463125.20, 16643762.05, 18348158.21]
					}
				};
				
				var chart = new Highcharts.Chart({
					chart: {
						renderTo: "high-performance-high-potential-chart"
					},
					plotOptions: {
						series: {
							dataLabels: {
								allowOverlap: true	
							},
							marker: {
								enabled: false,
								radius: 6,
								symbol: "circle"
							},
							stacking: "normal",
							states: {
								hover: {
									enabled: false
								}
							}
						}
					},
					series: [{
						color: "#E31837",
						data: data.efunds.historical,
						fillColor: Highcharts.Color("#E31837").setOpacity(0.75).get('rgba'),
						name: "eFund",
						pointIntervalUnit: "month",
						pointStart: Date.UTC(2017,5),
						stack: 0,
						type: "area",
						zIndex: 4
					},{
						color: "#F47735",
						data: data.reit.historical,
						fillColor: Highcharts.Color("#F47735").setOpacity(0.75).get('rgba'),
						name: "eREIT",
						pointIntervalUnit: "month",
						pointStart: Date.UTC(2015,11),
						stack: 0,
						type: "area",
						zIndex: 3
					},{
						color: "#F6A01A",
						data: data.privateOfferings.historical,
						fillColor: Highcharts.Color("#F6A01A").setOpacity(0.75).get('rgba'),
						name: "National Real Estate<br>Crowdfunding",
						pointIntervalUnit: "month",
						pointStart: Date.UTC(2014,0),
						stack: 0,
						type: "area",
						zIndex: 2
					},{
						color: "#F5E31B",
						data: data.crowdFunding.historical,
						fillColor: Highcharts.Color("#F5E31B").setOpacity(0.75).get('rgba'),
						name: "Local Real Estate<br>Crowdfunding",
						pointIntervalUnit: "month",
						pointStart: Date.UTC(2013,0),
						stack: 0,
						type: "area"
					}],
					tooltip: {
						enabled: false	
					},
					xAxis: {
						labels: {
							formatter: function() {
								var date = new Date(this.value);
								var year = date.getFullYear();
								return "Dec " + (year);
							}	
						},
						min: Date.UTC(2012,0),
						max: Date.UTC(2018,0),
						type: "datetime"
					},
					yAxis: {
						labels: {
							formatter: function() {
								if(this.value === 0 || this.value > 400000000) {
									return null;
								} else {
									return "$" + this.value / 1000000 + "M";
								}
							}	
						},
						min: 0,
						max: 350000000,
						tickInterval: 50000000,
						title: {
							style: {
								fontSize: "14px"	
							},
							text: yAxisTitle
						}
					}
				});
			}
		};
	}
})(window.angular);